export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo17-38fb03c98b1d1b13ff369d4e6313bfd8.jpg";